import { put, takeLatest, call, takeEvery, all } from 'redux-saga/effects';
import i18n from 'i18next';

const axios = require('axios');

function* fetchData(action) {
  let type = `${action.type}_SUCCESS`;
  yield put({ type: 'loading' });
  const json = yield axios({
    method: action.request.METHOD,
    url: `${action.request.ENDPOINT}?lang=${i18n.language}`,
    headers: { accept: 'application/json' },
    timeout: 40000,
    data: action.request.PAYLOAD,
  })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      type = `${action.type}_ERROR`;
      return error;
    })
    .finally(function () {});
  yield put({ type, payload: json });
}

export default function* rootSaga() {
  yield takeLatest('SEND_FORM', fetchData);
  yield takeLatest('GET_DATA', fetchData);
}
